<template>
  <div>
    <el-dialog v-loading="loading.dialog" class="alloca_model_dialog" top="5vh" center title="关联需求" width="80%"
               :before-close="handleClose" :visible.sync="dialogVisible" :append-to-body="true" :close-on-click-modal="false">
      <el-form size="mini" ref="form" :rules="rules" :model="form">
        <div style="display: flex;">
          <el-form-item label="需求名称" prop="demandName" :label-width="formLabelWidth">
            <el-input v-model="form.demandName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="项目名称" prop="projectName" :label-width="formLabelWidth">
            <el-input v-model="form.projectName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="产品" prop="pmId" :label-width="formLabelWidth">
            <el-select autocomplete="off" size="mini" v-model="form.pmId" filterable placeholder="请选择产品" clearable>
              <el-option v-for="(key, value)  in allUserList.ALLUSERTYPE2" :key="key" :label="key" :value="value" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button style="margin-left:60px;letter-spacing: 2px;font-weight: bold;font-size: 12px;" type="primary"
                       @click="formSearch('reset','search')">查询
            </el-button>
          </el-form-item>
        </div>
      </el-form>
      <div>
        <el-table ref="multipleTable" :data="tableData" border tooltip-effect="dark" style="width: 100%" :stripe="true"
                  highlight-current-row @selection-change="handleSelectionChange"  @row-click="rowselect" :header-cell-style="getCellClass" :cell-style="getRowClass">
          <el-table-column type="selection" width="55" :selectable="selectable" >
          </el-table-column>
          <el-table-column prop="id" label="需求ID" width="120" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="demandName" label="需求名称" min-width="120" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="projectName" label="项目名称" min-width="120" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="pm" label="产品" width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{scope.row.pm.nameZh ? scope.row.pm.nameZh: ''}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="statusDesc" label="状态" width="120" show-overflow-tooltip>
          </el-table-column>
        </el-table>
                <div class="block devOpsSpace_page">
                  <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                                 :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="[10, 25, 50, 100]"
                                 layout="total, prev, pager, next, sizes" :total="count">
                  </el-pagination>
                </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmChoose">确 定</el-button>
        <el-button type="success" @click="handleClose">取 消</el-button>
      </div>
      <Task v-if="dialogVisibleTask" :dialogVisible='dialogVisibleTask' :hideDialogVisible="handleTaskClose" :formInfo="formTaskInfo" />
    </el-dialog>

  </div>
</template>
<script>
import Task from '@/views/tops/devOps/producerSpace/components/task.vue'
import {mapState} from "vuex";
import {getDevOpsSpaceAllDemandListApi, getDevOpsSpaceFindDevelopTaskApi} from "@/server/tops/devOps";

export default {
  components:{Task},
  props: {
    demand_id: {
      default: '',
    },
    addData: {
      type:Object,
      default: function () {
        return {}
      },
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
    getChooseDemand: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
  },
  data() {
    return {
      tableData: [],
      selectData: [],
      loading: {
        dialog: false,
        submit: false,
        submitReviewed: false,
        submitRollBack:false,
      },
      form:{
        devTaskName:'',
        module:'',
        developerId:'',
      },
      formLabelWidth: '140px',
      currentPage: 1, // 当前页
      pageNo: 1,
      pageSize: 10,
      count: 0,
      formTaskInfo: '',
      dialogVisibleTask: false,
    }
  },
  computed: {
    ...mapState(
        {
          allSelect: (state) => state.devOps.ALLSELECT,
          allSystem: (state) => state.devOps.ALLSYSTEM,
          allUserList: (state) => state.devOps.ALLUSERLIST,
        }
    ),
  },
  async mounted() {
    this.$nextTick(async () => {
      await this.getDemand();
       // this.tableData.forEach((v, i) => {
       //   let result = addData.find(obj => obj.id === v.id)
       //   if (result) {
       //     this.$refs.multipleTable.toggleRowSelection(v, true);
       //   }
       // });
    })
  },
  async created() {
    // await this.getTask();
  },
  methods:{
    selectable(row, index) {
      if(this.demand_id && this.demand_id == row.id){
        return false;
      }else{
        return true;
      }
    },
    handleSelectionChange(selection) {
      if (selection.length > 1) {
        this.$refs.multipleTable.clearSelection()
        this.$refs.multipleTable.toggleRowSelection(selection.pop())
      } else if (selection.length === 1) {
        this.selectData = selection.pop()
      } else {
        this.selectData = {}
      }
      // this.selectData = val;
    },
    rowselect(row) {
       if(!(this.demand_id && this.demand_id == row.id)){
        this.$refs.multipleTable.toggleRowSelection(row);
       }
    },
    async  getDemand(){
      const params = {...this.form,module: this.form.module.toString(),demandId:this.demand_id,pageNo:this.currentPage,pageSize:this.pageSize,status:12,};
      await  getDevOpsSpaceAllDemandListApi(params).then((res)=>{
        this.tableData = res.data;
        this.count = res.count;
      });
      let addData = this.addData;
      this.tableData.forEach((v, i) => {
         if (v.id == addData.id) {
          this.$refs.multipleTable.toggleRowSelection(v, true);
         }
      });
    },
    // 关闭弹窗
    handleClose() {
      if(this.back){
        this.hideDialogVisible('demand')
      }else{
        this.hideDialogVisible()
      }
    },
    // 分页
    handleSizeChange(val) {
      this.pageNo = 1;
      this.currentPage = 1;
      this.pageSize = val;
      this.getDemand();
    },
    // 分页事件
    handleCurrentChange(val) {
      this.getDemand();
    },
    async formSearch(type,key) {
      if(type === 'reset'){
        this.pageNo = 1;
        this.currentPage = 1;
      }
      this.getDemand();
    },
    confirmChoose(){
      this.getChooseDemand(this.selectData);
      this.handleClose();
    },
    linkToModel(row){
      let newRow = {...row,taskId:row.id};
      this.formTaskInfo = newRow;
      this.dialogVisibleTask = true;
    },
    getCellClass(row, column, rowIndex, columnIndex) {
      return "padding: 4px 0;height:20px;background:#7F7F7F;color:#fff;font-size:14px;"
    },
    // 表格样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if(columnIndex == 1){
        return "border:none;border-top:1px solid #EBEEF5;font-size: 12px;font-weight: bold;padding:6px 0;";
      }
      return "border:none;border-top:1px solid #EBEEF5;font-size: 12px;padding:6px 0;";
    },
    handleTaskClose(){
      this.getDemand();
      this.dialogVisibleTask = false;

    },
  }
}
</script>
<style lang="scss">
.alloca_model_dialog{
  .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
    margin-bottom: 0px;
  }
}
.table_text_click_new {
  text-decoration: underline;
  color: #409EFF;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

</style>
